import { Input } from 'antd'

export const InputEmail = (props) => {
  return <Input type="email" style={{ maxWidth: '450px' }} {...props} />
}
